import { render, staticRenderFns } from "./AddBilling.vue?vue&type=template&id=4dc88140"
import script from "./AddBilling.vue?vue&type=script&lang=js"
export * from "./AddBilling.vue?vue&type=script&lang=js"
import style0 from "./AddBilling.vue?vue&type=style&index=0&id=4dc88140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports